import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';
import type { W_Order_FindOrderReportTable_QP_AdditionalFilters } from '../findForOrderReportTable';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/getTotalOrderReportAmount${`?query=${Encoded<string>}&startDate=${string}&endDate=${string}&timezone=${string}&additionalFilters=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/getTotalOrderReportAmount`;

export const URL = (
	tableRequestModel: TableQuery,
	startDate: Nullable<string>,
	endDate: Nullable<string>,
	timezone: Nullable<string>,
	additionalFilters: W_Order_FindOrderReportTable_QP_AdditionalFilters
): RouteDefinition => `${baseRoute}/getTotalOrderReportAmount?query=${encodeURIComponent((JSON.stringify(tableRequestModel)))}&startDate=${startDate}&endDate=${endDate}&timezone=${timezone}&additionalFilters=${encodeURIComponent((JSON.stringify(additionalFilters)))}`;
